<template>
<div>
        <div class="damage columns">
        <h2>地质灾害自动化监测</h2>
        <div class="all">
          <p>
              我国地质和地理环境复杂，气候条件时空差异大，地质灾害种类多、分布广、危害大，是世界上地质灾害最严重的国家之一。地质 灾害使得建筑物、基础设施、农田受损，生态环境恶化，威胁居民财产和生命安全，激化工农矛盾，是影响地区经济发展和社会安 定的重要因素和关键问题。主要的地质灾害监测：滑坡监测，泥石流监测，崩塌监测，沉降监测。


          </p>
        </div>
        <div class="brief_box">

            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>项目基本情况</h5>
            </div>
            <p>为给防灾减灾决策提供科学依据，为地质灾害防治工作质量、效 率和管理水平的提高奠定基础，实现了地质灾害防治管理的科学 化、信息化、标准化和可视化</p>
             
              <div class="title_box row">
                <div class="blue_line"></div>
                <h5>监测参数</h5>
            </div>
            <p>表面位移（GNSS和测量机器人）</p>
            <p>深部位移（多点位移计/测斜计）</p>
            <p>土体压力（土压力计）</p>
            <p>土体位移（土位移计）</p>
            <p>支护受力（应力应变）</p>
            <p>支护裂缝（裂缝计）</p>
            <p>内部水压力（渗压计）</p>
            <p>气象环境（气象站）</p>
            <p>地震（加速度传感器）</p>
            <div class="title_box row">
                <div class="blue_line"></div>
                <h5>推荐设备</h5>
            </div>
            <p>监测设备：</p>
            <p>RocBox RT2000-GS北斗监测GNSS</p>
            <p>Topcon MS/DS系列测量机器人</p>
            <p>RT-VW-4300振弦式多点位移计</p>
            <p>RT-VW-2400振弦式土压力计</p>
            <p>RT-VW-2300振弦式</p>
            <p>钢筋计RT-VW-4100振弦式裂缝计</p>
            <p>RT-VW-3100振弦式渗压计，RT-DT-8100系列多参数气象站</p>
            <p>低频测振传感器</p>
            
            <h6>监测终端:</h6>
            <p>RocBox RT2000</p> 
            <p>RocMIoT监测物联网系列产品</p>  
            <p>振动信号采集仪</p>  
</p>              
        </div>    
    </div>
     <foot></foot>

</div>

</template>
<style>
.damage {
  width: 100%;
  background-color: rgba(245, 245, 245, 1);
}
h2 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  margin-top: 0.55rem;
  margin-bottom: 0.36rem;
}
.all {
  width: 11.4rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 0.3rem;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
}
.brief_box {
  width: 12rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin-top: 0.2rem;
  margin-bottom: 0.67rem;
  padding-bottom: .64rem;
}
.brief_box p,
 .brief_box h6{
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-left: 0.4rem;
  padding-top: 0.1rem;
}
.brief_box h6{
    padding-top: .3rem;
}
.title_box {
  margin-left: 0.4rem;
  margin-top: 0.37rem;
  font-size: 0.16rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  line-height: 0.2rem;
}
.blue_line {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>





// WEBPACK FOOTER //
// src/homepages/solutionpage/damage.vue